import { useContext } from "react";
import UserContext from "../../../services/Context/UserContext";

export default function useIsDentist() {
    const { user } = useContext(UserContext)
    return user?.category?.id === 'dentaire';
}